export interface Article {
  id: string;
  title: string;
  category: string;
  summary: string;
  readTime: string;
  updatedAt: string;
  cover: string;
  tags: string[];
  featured?: boolean;
  content: { heading: string; body: string[] }[];
}

export const articles: Article[] = [
  {
    id: "amule-eggs-meaning",
    title: "亚梦的三个守护甜心，分别代表怎样的自己？",
    category: "角色解析",
    summary:
      "小兰的运动、美琪的艺术、小丝的温柔，三颗守护蛋其实对应着亚梦性格中三个常被压抑的侧面。读懂她们，就读懂亚梦的成长。",
    readTime: "6 分钟",
    updatedAt: "2026-08-10",
    featured: true,
    cover:
      "https://readdy.ai/api/search-image?query=pastel%20magical%20girl%20anime%20style%20illustration%20of%20three%20cute%20glowing%20guardian%20eggs%20floating%20together%20in%20soft%20pink%20mint%20and%20gold%2C%20sparkles%20and%20warm%20bokeh%2C%20dreamy%20storybook%20background%2C%20clean%20composition&width=800&height=520&seq=article-eggs-meaning&orientation=landscape",
    tags: ["角色解析", "守护甜心", "亚梦"],
    content: [
      {
        heading: "三颗蛋，三种被隐藏的自己",
        body: [
          "日奈森亚梦看起来酷酷的、总是很冷静，但那只是因为害怕被误解，才习惯性地用冷漠包裹自己。守护蛋之所以会在她沉睡时孵化，正是因为蛋里装着的，是她渴望成为却始终不敢承认的模样。",
          "甜心小兰代表『运动与活力』，对应着亚梦身体里那股想放开手脚、自由奔跑的冲劲；美琪代表『艺术与审美』，对应着她细腻敏感、爱幻想的一面；小丝则代表『温柔与照顾』，对应着亚梦其实非常温暖、很会为他人着想的本质。",
        ],
      },
      {
        heading: "守护甜心不是『别人』，而是『可能成为的你』",
        body: [
          "守护蛋的秘密在于：蛋里孵出的不是某个陌生的神，而是自己『理想中』或『本真』的那一面。当亚梦能够坦然面对并接纳这些侧面时，她才能真正变身，而不是靠伪装。",
          "这也是为什么整部作品反复强调『不要模仿理想的自己』——真正的成长，是诚实地拥抱自己本来的样子，而不是活成别人眼中的完美形象。",
        ],
      },
      {
        heading: "三种能力，其实是一种完整",
        body: [
          "运动、艺术、温柔，表面上是三种不同的特长，本质上却共同拼出一个完整而鲜活的亚梦。当三个甜心齐心协力时，亚梦才展现出最强大的力量，这正是作品想传达的：接纳全部的自己，才是真正的强大。",
        ],
      },
    ],
  },
  {
    id: "guardian-egg-x-egg",
    title: "守护蛋、X 蛋与坏蛋：一颗蛋的心路历程",
    category: "设定解析",
    summary:
      "守护蛋为何会变成 X 蛋？复活社又在打什么算盘？梳理蛋的三种形态，帮你一眼看懂守护甜心的核心世界观。",
    readTime: "8 分钟",
    updatedAt: "2026-08-05",
    featured: true,
    cover:
      "https://readdy.ai/api/search-image?query=pastel%20magical%20girl%20anime%20style%20illustration%20of%20a%20cracked%20dark%20glowing%20egg%20transitioning%20into%20a%20bright%20pink%20egg%2C%20split%20scene%20with%20moody%20and%20warm%20sides%2C%20floating%20sparkles%2C%20dreamy%20storybook%20background&width=800&height=520&seq=article-egg-journey&orientation=landscape",
    tags: ["设定解析", "守护蛋", "X蛋"],
    content: [
      {
        heading: "守护蛋是什么？",
        body: [
          "守护蛋是『孩子心中理想自己的具象化』。当一个人心中怀有强烈而真实的渴望时，蛋就会出现，并有机会孵出守护甜心，成为并肩作战的伙伴。",
        ],
      },
      {
        heading: "为什么会变成 X 蛋？",
        body: [
          "当蛋的主人开始否定自己、失去信心、或被迫放弃真正的梦想时，蛋就会受到污染，变成画着大叉的 X 蛋。X 蛋不是怪物，而是被忽略的真心在求救。",
          "守护者的使命，并不是打败 X 蛋，而是用理解和拥抱去『净化』它，把它重新带回主人的心里——这也是全剧最温柔的主题之一。",
        ],
      },
      {
        heading: "复活社到底在做什么？",
        body: [
          "复活社（Easter）试图收集和改造守护蛋，追逐其中隐藏的神秘力量。但他们对力量的执念，恰恰是造成 X 蛋与悲剧的根源。作品借此探讨：当成人世界用利益去衡量童心时，会带来怎样的伤害。",
        ],
      },
    ],
  },
  {
    id: "ikuto-amu-bond",
    title: "几斗与亚梦：一根猫尾巴牵起的羁绊",
    category: "角色解析",
    summary:
      "一边是神秘叛逆的少年，一边是努力守护的 Joker。几斗与亚梦之间若即若离的关系，藏着整部作品最动人的温柔。",
    readTime: "7 分钟",
    updatedAt: "2026-07-28",
    cover:
      "https://readdy.ai/api/search-image?query=pastel%20magical%20girl%20anime%20style%20illustration%20of%20a%20black%20cat%20silhouette%20and%20a%20pink%20sparkling%20heart%20facing%20each%20other%20under%20soft%20warm%20light%2C%20dreamy%20storybook%20night%20sky%20with%20stars%2C%20clean%20composition&width=800&height=520&seq=article-ikuto-bond&orientation=landscape",
    tags: ["角色解析", "几斗", "亚梦"],
    content: [
      {
        heading: "看似对立的两个人",
        body: [
          "几斗总是带着猫一样的慵懒与疏离，却又在关键时刻一次次出现在亚梦身边。他背负着家族的阴影与复活社的控制，却从未真正伤害过亚梦。",
        ],
      },
      {
        heading: "他们都在用冷漠保护别人",
        body: [
          "亚梦用表面的冷酷保护自己不被看穿，几斗则用玩世不恭掩饰内心的伤痕。两个『假装坚强』的人，在彼此的陪伴里慢慢学会了真正地相信与依赖。",
          "这段羁绊动人的地方在于：没有轰轰烈烈的告白，却每一次都在对方最需要时出现——一根猫尾巴，悄悄牵起了两颗心。",
        ],
      },
      {
        heading: "守护与被守护",
        body: [
          "亚梦一次次想要守护几斗，几斗也一次次在黑暗中为亚梦挡住危险。这种『互相守护』的关系，正是守护甜心想要表达的成长与爱。",
        ],
      },
    ],
  },
  {
    id: "final-ending-overview",
    title: "守护甜心结局大梳理：所有角色的最终归宿",
    category: "结局解析",
    summary:
      "从守护者到复活社，从甜心到几斗，逐一梳理守护甜心系列每位重要角色的最终结局与去向，附故事脉络时间线。",
    readTime: "9 分钟",
    updatedAt: "2026-07-20",
    cover:
      "https://readdy.ai/api/search-image?query=pastel%20magical%20girl%20anime%20style%20illustration%20of%20a%20group%20of%20silhouettes%20walking%20toward%20a%20warm%20golden%20sunrise%20with%20floating%20guardian%20eggs%20and%20sparkles%2C%20dreamy%20storybook%20horizon%2C%20hopeful%20tone&width=800&height=520&seq=article-ending-overview&orientation=landscape",
    tags: ["结局解析", "角色结局", "时间线"],
    content: [
      {
        heading: "主线结局的一句话概括",
        body: [
          "守护甜心的结局并非『谁赢了谁输了』，而是所有人都在经历成长后，找到了与自己和解、继续前行的方式。守护蛋与 X 蛋的纷争，最终回归到了『理解与接纳』的原点。",
        ],
      },
      {
        heading: "守护者们的归宿",
        body: [
          "亚梦在一次次守护中真正接纳了自己；守护者们各自在梦想与责任之间找到了平衡；守护甜心们则继续以伙伴的身份，陪伴主人走向更远的未来。",
        ],
      },
      {
        heading: "几斗与复活社的落点",
        body: [
          "几斗最终摆脱了复活社的阴影，得以按自己的方式生活；复活社对力量的执念也随着对真心的理解而软化，为整个系列留下了温暖而开放的余韵。",
        ],
      },
    ],
  },
  {
    id: "easter-mystery",
    title: "复活社 Easter 到底在追逐什么？",
    category: "剧情深度解读",
    summary:
      "表面上复活社在收集守护蛋，实际上他们的执念背后藏着更深的欲望。拆解复活社的动机，也就拆解了守护甜心的核心矛盾。",
    readTime: "6 分钟",
    updatedAt: "2026-07-12",
    cover:
      "https://readdy.ai/api/search-image?query=pastel%20magical%20girl%20anime%20style%20illustration%20of%20a%20mysterious%20dark%20silhouette%20tower%20with%20a%20glowing%20golden%20egg%20at%20the%20top%2C%20soft%20mist%20and%20sparkles%2C%20dreamy%20moody%20storybook%20atmosphere%2C%20clean%20composition&width=800&height=520&seq=article-easter-mystery&orientation=landscape",
    tags: ["深度解读", "复活社", "世界观"],
    content: [
      {
        heading: "收集蛋，其实是收集『希望』",
        body: [
          "复活社对守护蛋的追逐，本质上是对『童心中纯粹希望』的贪婪。他们误以为控制这种力量就能掌控一切，却没想到这恰恰是 X 蛋产生的根源。",
        ],
      },
      {
        heading: "成人世界 vs 童心的对照",
        body: [
          "作品用复活社作为『被利益扭曲的成人世界』的隐喻，与守护者守护童心的立场形成强烈对照。守护甜心之所以打动人心，正是因为它在讲述成人也需要的温柔与勇气。",
        ],
      },
    ],
  },
  {
    id: "why-classic",
    title: "为什么守护甜心是很多人的童年白月光？",
    category: "影评随想",
    summary:
      "从变身美学到角色成长，从治愈系设定到青春的悸动，聊聊守护甜心为何能穿越时间，成为一代人心中的经典。",
    readTime: "5 分钟",
    updatedAt: "2026-07-02",
    cover:
      "https://readdy.ai/api/search-image?query=pastel%20magical%20girl%20anime%20style%20illustration%20of%20a%20sparkling%20heart%20with%20wings%20surrounded%20by%20soft%20pink%20confetti%20and%20glowing%20light%2C%20dreamy%20nostalgic%20storybook%20background%2C%20clean%20composition&width=800&height=520&seq=article-why-classic&orientation=landscape",
    tags: ["影评", "回忆", "经典"],
    content: [
      {
        heading: "变身，是每个孩子向往的仪式",
        body: [
          "守护甜心的变身设定，天然契合孩子对『成为理想自己』的想象。戴上皇冠、穿上守护者制服的那一刻，其实是无数人内心深处渴望的自我确认。",
        ],
      },
      {
        heading: "它一直在教我们接纳自己",
        body: [
          "无论过了多少年，守护甜心反复讲述的道理都没有过时：你不用活成别人期待的样子，温柔地接纳真实的自己，就已经足够勇敢。",
        ],
      },
    ],
  },
];